"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4546],{

/***/ 724546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CollectionWidget_CollectionWidget1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionWidget/collectionCards.js


var DEFAULT_IMAGE_FOR_COLLECTION = "https://cdn.dotpe.in/longtail/store-items/default_image.png";
var Card1 = function(param) {
    var data = param.data, widgetConfig = param.widgetConfig, onClick = param.onClick, animationType = param.animationType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cardWidget cardWidget1",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cardWidgetImage animation-".concat(animationType),
                style: {
                    backgroundImage: 'url("'.concat((data === null || data === void 0 ? void 0 : data.image_url) || DEFAULT_IMAGE_FOR_COLLECTION, '")'),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "cover"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mv0 cardWidgetText",
                children: (data === null || data === void 0 ? void 0 : data.name) || "Available"
            })
        ]
    });
};
var Card2 = function(param) {
    var data = param.data, widgetConfig = param.widgetConfig, onClick = param.onClick, animationType = param.animationType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cardWidget cardWidget2",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cardWidgetImage animation-".concat(animationType),
                    style: {
                        backgroundImage: 'url("'.concat((data === null || data === void 0 ? void 0 : data.image_url) || DEFAULT_IMAGE_FOR_COLLECTION, '")'),
                        paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                        backgroundPosition: "center",
                        backgroundSize: "cover"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mv0 cardWidgetText",
                children: (data === null || data === void 0 ? void 0 : data.name) || "Available"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/eventLogger.js
var eventLogger = __webpack_require__(204134);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/constants/common.ts
var common = __webpack_require__(742783);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionWidget/CollectionWidget1/index.js









var CollectionWidget1 = function(props) {
    var ref;
    // const [widgetConfig, setWidgetConfig] = useState(props.config || null);
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            collections: state.catalogReducer.collections
        };
    }), collections = ref1.collections, storeData = ref1.storeData;
    var widgetConfig = props.config;
    var storeInfo = storeData === null || storeData === void 0 ? void 0 : storeData.store_info;
    var animationTypeIndex = (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.collection_animation) || 0;
    var animationType = constants/* COLLECTION_CARD_ANIMATION_TYPE */.po[animationTypeIndex];
    // useEffect(() => {
    //   if (props?.config && Object.keys(props.config)) {
    //     setWidgetConfig(props.config);
    //   }
    // }, [props?.config]);
    var ifMax5Collections = function() {
        return (collections === null || collections === void 0 ? void 0 : collections.length) <= 5;
    };
    var handleCollectionCardClick = function(collection) {
        (0,eventLogger/* default */.Z)(common/* EVENT_NAMES.COLLECTION_WIDGET_CARD_CLICK */.Kg.COLLECTION_WIDGET_CARD_CLICK, {
            collectionId: collection.id
        }, true);
        window.location.href = (0,routes.getRoute)(routes.PATH.collectionCategories(collection.id), storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.domain);
    };
    /**
   * render specific collection card from the given prop
   * CollectionWidget1 -> Card1
   *
   * Based on type of card type
   * different cards are rendered
   *
   * Aspect ratio of cards are calculated from the
   * aspect_ratio prop from BE
   *
   * @param {Object} data
   * @param {number} idx
   * @param {number} cardType
   * @return {JSX} component from switch case
   */ var _renderCollectionCard = function(data, idx, cardType) {
        switch(cardType){
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card1, {
                    widgetConfig: widgetConfig,
                    data: data,
                    onClick: function() {
                        return handleCollectionCardClick(data);
                    },
                    animationType: animationType
                }, idx);
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card2, {
                    widgetConfig: widgetConfig,
                    data: data,
                    onClick: function() {
                        return handleCollectionCardClick(data);
                    },
                    animationType: animationType
                }, idx);
        }
    };
    /**
   * returns the number of columns columns from
   * props.config based on the device width
   * @return {number} no of columns
   */ var returnGridTemplateColumns = function() {
        var ref, ref1, ref2, ref3;
        if (deviceWidth/* deviceWidth */.o > 786 && ifMax5Collections()) return {};
        return deviceWidth/* deviceWidth */.o <= 786 ? widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref = widgetConfig.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.cols : widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref2 = widgetConfig.desktop) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.cols;
    };
    /**
   * returns the grid gap value based on
   * deviceWidth
   * @return {number} grid gap value
   */ var returnGridSpacing = function() {
        var ref, ref1;
        if (deviceWidth/* deviceWidth */.o > 786 && ifMax5Collections()) return "auto";
        return deviceWidth/* deviceWidth */.o <= 786 ? (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref = widgetConfig.mobile) === null || ref === void 0 ? void 0 : ref.spacing) || 20 : (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref1 = widgetConfig.desktop) === null || ref1 === void 0 ? void 0 : ref1.spacing) || 20;
    };
    var bodyStyles = function() {
        if (deviceWidth/* deviceWidth */.o <= 786) {
            return {
                gridTemplateColumns: "repeat(".concat(returnGridTemplateColumns(), ", 1fr)"),
                gridGap: "".concat(returnGridSpacing(), "px")
            };
        } else {
            return {
                gridTemplateColumns: !ifMax5Collections() ? "repeat(".concat(returnGridTemplateColumns(), ", 1fr)") : null,
                gridGap: !ifMax5Collections() ? "".concat(returnGridSpacing(), "px") : null
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "collectionWidget1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "collectionWidget1--header",
                children: (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.heading) || "Shop By Collections"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collectionWidget1__body tw-justify-center ".concat(deviceWidth/* deviceWidth */.o > 786 && ifMax5Collections() ? "horizontal-view" : "grid-view"),
                style: bodyStyles(),
                children: (collections === null || collections === void 0 ? void 0 : collections.length) ? collections === null || collections === void 0 ? void 0 : collections.map(function(data, index) {
                    return _renderCollectionCard(data, index, props.cardType);
                }) : null
            })
        ]
    });
};
/* harmony default export */ var CollectionWidget_CollectionWidget1 = (CollectionWidget1);


/***/ }),

/***/ 204134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(626042);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(467936);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);



var eventLogger = function(eventName) {
    var additionalData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, showInConsole = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var userData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.data;
    var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        email: (userData === null || userData === void 0 ? void 0 : userData.email) || ""
    }, additionalData);
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .pushEventsLog */ .U)({
        event_name: eventName,
        data: eventData
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (eventLogger);


/***/ })

}]);